import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
/**
 * @param  ele          要生成 pdf 的DOM元素（容器）
 * @param  fileObj     PDF文件生成后的文件名字
 * */
export function downloadPDF(ele: any, fileObj: any) {
  const canvas = document.createElement('canvas'); // 生成canvas上下文
  const context: any = canvas.getContext('2d');
  const _w = ele.clientWidth; //获取需要导出pdf区域的宽度和高度
  let _h = ele.clientHeight;
  const scale = 3; //将画布宽&&高放大三倍，提高清晰度
  if (_w > _h) {
    _h = _w;
  }
  canvas.width = _w * scale;
  canvas.height = _h * scale;
  context.scale(scale, scale);
  const opts = {
    scale: 1,
    width: _w, //dom 原始宽度
    height: _h,
    canvas: canvas,
    useCORS: true, //允许canvas画布内可以跨域请求外部链接图片, 允许跨域请求。
  };
  html2canvas(ele, opts).then(canvas => {
    const contentWidth = canvas.width / scale;
    const contentHeight = canvas.height / scale;
    const pdf = new jsPDF('p', 'pt', [contentWidth, contentHeight]); //自定义宽高
    const pageData = canvas.toDataURL('image/jpeg', 1.0); //转换图片为dataURL
    pdf.addImage(pageData, 'JPEG', 0, 0, contentWidth, contentHeight); //添加图像到页面
    pdf.save(`${fileObj.type} - ${fileObj.workOrder}` + '.pdf');
  });

  // let shareContent: any = document.querySelector("#imageWrapper"); //需要截图的包裹的（原生的）DOM 对象
  // let width = shareContent.offsetWidth; //获取dom 宽度
  // let height = shareContent.offsetHeight; //获取dom 高度
  // let canvas: any = document.createElement("canvas"); //创建一个canvas节点
  // let scale = 2; //定义任意放大倍数 支持小数
  // canvas.width = width * scale; //定义canvas 宽度 * 缩放，在此我是把canvas放大了2倍
  // canvas.height = height * scale; //定义canvas高度 *缩放
  // canvas.getContext("2d").scale(scale, scale); //获取context,设置scale
  // html2canvas(shareContent, {
  //   useCORS: true,
  // }).then(function(canvas) {
  //   let context: any = canvas.getContext("2d");
  //   // 【重要】关闭抗锯齿
  //   context.mozImageSmoothingEnabled = false;
  //   context.webkitImageSmoothingEnabled = false;
  //   context.msImageSmoothingEnabled = false;
  //   context.imageSmoothingEnabled = false;
  //
  //   let imgData = canvas.toDataURL("image/jpeg", 1.0); //转化成base64格式,可上网了解此格式
  //   let img = new Image();
  //   img.src = imgData;
  //   img.onload = function() {
  //     img.width = img.width / 2; //因为在上面放大了2倍，生成image之后要/2
  //     img.height = img.height / 2;
  //     // img.style.transform = "scale(0.5)";
  //     if (width > height) {
  //       //此可以根据打印的大小进行自动调节
  //       let doc = new jsPDF("l", "mm", [width * 0.555, height * 0.555]);
  //       doc.addImage(imgData, "JPEG", 10, 0, width * 0.505, height * 0.545);
  //       doc.save(`${fileObj.type} - ${fileObj.workOrder}` + ".pdf");
  //     } else {
  //       let doc = new jsPDF("p", "mm", [width * 0.555, height * 0.555]);
  //       doc.addImage(imgData, "JPEG", 10, 0, width * 0.505, height * 0.545);
  //       doc.save(`${fileObj.type} - ${fileObj.workOrder}` + ".pdf");
  //     }
  //   };
  // });
}

// export function downloadPDF(ele: any) {
//   let opts = {
//     // scale: 4,
//     useCORS: true  //允许canvas画布内可以跨域请求外部链接图片, 允许跨域请求。
//   };
//   html2canvas(ele, opts).then((canvas: any) => {
//     let contentWidth: any = canvas.width;
//     let contentHeight: any = canvas.height;
//     // 一页pdf
//     let pageHeight: any = contentWidth  / 592.28 * 841.89;
//     let leftHeight: any = contentHeight;
//     let position = 0;
//     let imgWidth = 595.28;
//     let imgHeight = 592.28 / contentWidth * contentHeight;
//     let pageData = canvas.toDataURL('image/jpeg', 1.0)  //转换图片为dataURL
//     let pdf = new jsPDF('p', 'pt', 'a4');
//     if (leftHeight < pageHeight) {
//       pdf.addImage(pageData, 'JPEG', 0, 0, imgWidth, imgHeight);
//     } else {
//       while (leftHeight > 0) {
//         pdf.addImage(pageData, 'JPEG', 0, position, imgWidth, imgHeight);
//         leftHeight -= pageHeight;
//         // leftHeight = leftHeight + 60;
//         position -= 841.89;
//         if (leftHeight > 0) {
//           pdf.addPage();
//         }
//       }
//     }
//     pdf.save('作业票');
//   })
// }
